import { createClient } from '@supabase/supabase-js';

/**
 * Supabase client — compatible Vite (browser) ET Node.js (scraper).
 *
 * isNode : true si on tourne dans Node.js (scraper), false dans le navigateur.
 * En navigateur, process n'existe pas → on lit import.meta.env (Vite).
 * En Node.js ESM, import.meta.env est undefined → on lit process.env
 * (après que dotenv/config ait été chargé en premier dans populate-deadlines.js).
 */
const isNode = typeof process !== 'undefined' && !!process.env?.VITE_SUPABASE_URL;

const supabaseUrl = isNode
  ? process.env.VITE_SUPABASE_URL
  : import.meta.env.VITE_SUPABASE_URL;

const supabaseAnonKey = isNode
  ? process.env.VITE_SUPABASE_ANON_KEY
  : import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Variables manquantes : VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY doivent être définies dans .env'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Client admin (service role) — uniquement disponible côté Node.js scraper.
// Nécessite SUPABASE_SERVICE_ROLE_KEY dans .env pour contourner RLS.
const supabaseServiceRoleKey = isNode ? process.env.SUPABASE_SERVICE_ROLE_KEY : null;
export const supabaseAdmin = supabaseServiceRoleKey
    ? createClient(supabaseUrl, supabaseServiceRoleKey)
    : null;
